import { createAction } from '@reduxjs/toolkit';
export const POST_LOGIN = 'POST_LOGIN';
export const postLoginAction = createAction(POST_LOGIN);